export const UserActionTypes = {
    LOGIN_START:'LOGIN_START',
    LOGIN_SUCCESS:'LOGIN_SUCCESS',
    LOGIN_FAILURE:'LOGIN_FAILURE',
    SIGN_OUT:'SIGN_OUT',
    GET_USERS_START:'GET_USERS_START',
    GET_USERS_SUCCESS:'GET_USERS_SUCCESS',
    GET_USERS_FAILURE:'GET_USERS_FAILURE',

}